<template>
  <asc-accent-button
    :button-text="buttonText"
    :disabled="disabled"
    :on-click="handleClick"
  ></asc-accent-button>
</template>

<script>
import AscAccentButton from './AscAccentButton'

export default {
  name: 'AscNavigationButton',

  components: {
    AscAccentButton,
  },

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: '/',
    },
    outlineOnly: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClick() {
      this.$router.push(this.path)
    },
  },
}
</script>
